import { GameState } from '../../../types/game';
import { finalizeTrailingSegment } from '../../../domain/segmentsCapture';

export function handleEndTurnInternal(state: GameState, playerId: string): GameState {
  if (state.mode === 'REAL' || !state.turnCycle) return state;
  if (state.turnCycle.activePlayerId !== playerId) return state;
  const segments = finalizeTrailingSegment(state);
  return {
    ...state,
    segments,
    segmentsOwnerId: state.turnCycle?.activePlayerId || state.segmentsOwnerId,
    turnCycle: { ...state.turnCycle, status: 'FINALIZING' },
  };
}

export function handleMarkTurnFinalizing(state: GameState): GameState {
  if (state.mode === 'REAL' || !state.turnCycle) return state;
  return {
    ...state,
    turnCycle: { ...state.turnCycle, status: 'FINALIZING' },
  };
}
